import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loginBySignature } from './pages/Login';
import reportWebVitals from './reportWebVitals';
import LuaModule from "./lua";
import { Result } from './common/js/common';
import { Request, Method } from './common/js/request';
import { ajax } from './common/js/utils';
import * as Loading from './components/Loading';
import * as Message from './common/js/message';
import ClipboardJS from 'clipboard';
import './base.css';

function initClipboard() {
    const clipboard = new ClipboardJS('[data-clipboard-text]');
    clipboard.on("success", () => {
        Message.success("Copy successfully");
    });
}

function initRequest() {
    Request.defaultHttpRequestor = (method: Method, url: string, query: string | void, body: any) => {
        return new Promise(function (resolve, reject) {
            let opt = {
                method: method
            };
            ajax<any, any>(url, body, opt).then((respRet) => respRet.match(resolve, reject));
        });
    };
    Request.defaultDataUnwrapper = async (resp: any): Promise<Result<any, string>> => {
        if (undefined === resp.code) {
            console.error('unknown data type returned from server: \n', resp);
            return Result.Err('unknown data type returned from server');
        } else {
            if (resp.code === 0) {
                return Result.Ok(resp.data);
            } else {
                return Result.Err(resp.message);
            }
        }
    };
    Request.defaultLoadingHandler = (show: boolean): void => {
        if (show) {
            Loading.show();
        } else {
            Loading.hide();
        }
    };
    Request.defaultUnwrapErrorHandler = Message.error;
    Request.defaultReqErrorHandler = (err) => {
        Message.error(err.msg);
    };
}

async function initLua() {
    (window as any).Module = LuaModule;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', __webpack_public_path__ + 'wasm_lua/lua.wasm', true);
    xhr.responseType = 'arraybuffer';
    xhr.overrideMimeType("application/javascript");
    return new Promise(function (resolve, reject) {
        xhr.onload = function () {
            (LuaModule as any).wasmBinary = xhr.response;
            var script = document.createElement('script');
            script.src = __webpack_public_path__ + "wasm_lua/lua.js";
            script.onload = resolve;
            script.onerror = reject;
            document.body.appendChild(script);
        };
        xhr.onerror = reject;
        xhr.send();
    });
}

async function autoLogin() {
    let content = localStorage.getItem("keyPair");
    if (content) {
        let keyPair = JSON.parse(content);
        await loginBySignature(keyPair["publicKey"], keyPair["privateKey"]);
    }
}

export default async function start() {
    initClipboard();
    initRequest();
    await Promise.all([initLua(), autoLogin()]);
    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
}